var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.updateExists)?_c('button',{on:{"click":_vm.refreshApp}},[_vm._v("Nuova versione disponibile! Clicca per aggiornare")]):_c('router-view')
}
var staticRenderFns = []

export { render, staticRenderFns }